import { emphasize } from "@mui/material/styles";

export const generateColors = (baseColors, count) => {
    let colors = [];
    const colorsPerBaseColor = Math.ceil(count / baseColors.length);
    for (let i = 0; i < count; i++) {
        const colorIdx = Math.floor(i / baseColors.length);
        colors.push(
            emphasize(baseColors[i % baseColors.length], (0.8 / colorsPerBaseColor) * colorIdx)
        );
    }
    return colors;
};
